// packages/content/src/strings/push.ts (M1-T18, spec §10.4) — one title/body per PushKind
import type { StringBank } from '../schema/strings';
export default {
  mailTitle: 'You have mail', mailBody: '{count} new {count|letter|letters} in your mailbox.',
  residentMovedInTitle: '{name} moved in', residentMovedInBody: 'A new neighbour. Go and say hello.',
  constructionTitle: 'Your {levelName:lc} is ready', constructionBody: 'The builders finished overnight. Come and have a look.',
  villagerMovedInTitle: '{name} moved in', villagerMovedInBody: 'Someone new is unpacking in town.',
  villagerMovedOutTitle: '{name} moved away', villagerMovedOutBody: 'They left a letter for you.',
} as const satisfies StringBank;
